if (!customElements.get('op-final-offer')) {
  customElements.define('op-final-offer', class OpFinalOffer extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.select = this.querySelector('[data-op-variant-select]');
      this.idInput = this.querySelector('[name="id"]');
      this.quantityInput = this.querySelector('[name="quantity"]');
      this.price = this.querySelector('[data-op-price]');
      this.compare = this.querySelector('[data-op-compare-price]');
      this.button = this.querySelector('[data-op-submit]');
      this.label = this.querySelector('[data-op-submit-label]');
      this.image = this.querySelector('.op-final-offer__product-image');
      this.planMessage = this.querySelector('[data-op-plan-message]');
      this.handleState = this.handleState.bind(this);
      this.handleSelect = this.handleSelect.bind(this);
      document.addEventListener('op:purchase-state-change', this.handleState);
      this.select?.addEventListener('change', this.handleSelect);
      this.handleState({ detail: window.OpProductPurchaseState?.get(this.productId) });
    }

    disconnectedCallback() {
      document.removeEventListener('op:purchase-state-change', this.handleState);
      this.select?.removeEventListener('change', this.handleSelect);
    }

    // Display conversion is owned by OpCurrency; the Shopify amount stays put.
    setMoney(element, cents, baseText) {
      if (cents == null) { element.textContent = ''; return; }
      if (window.OpCurrency) {
        window.OpCurrency.render(element, cents, { baseText: baseText || undefined });
        return;
      }
      element.setAttribute('data-op-money', String(Math.round(Number(cents) || 0)));
      element.textContent = baseText || ((Number(cents) || 0) / 100).toFixed(2);
    }

    handleSelect() {
      window.OpProductPurchaseState?.requestVariant(this.productId, this.select.value, this.dataset.sectionId);
    }

    handleState(event) {
      const state = event?.detail;
      if (!state || String(state.productId) !== String(this.productId)) return;
      const variant = state.variant;
      const available = Boolean(variant?.id && state.canAdd);
      if (this.select && variant?.id) this.select.value = String(variant.id);
      if (this.idInput) { this.idInput.value = variant?.id || ''; this.idInput.disabled = !available; }
      if (this.quantityInput) this.quantityInput.value = state.quantity;
      // Total mode shows price and compare-at for the selected quantity; Shopify's own text is kept for a single item.
      const quantity = this.dataset.priceMode === 'total' ? Math.max(1, Number(state.quantity) || 1) : 1;
      if (this.price) this.setMoney(this.price, variant?.price == null ? null : variant.price * quantity, quantity === 1 ? variant?.price_formatted : undefined);
      if (this.compare) { const onSale = variant?.compare_at_price > variant?.price; this.compare.hidden = !onSale; if (onSale) this.setMoney(this.compare, variant.compare_at_price * quantity, quantity === 1 ? variant.compare_formatted : undefined); }
      if (this.image && this.dataset.syncImage === 'true' && variant?.image) this.image.src = variant.image;
      if (this.button) { this.button.disabled = !available; this.button.toggleAttribute('aria-disabled', !available); }
      if (this.label) this.label.textContent = state.requiresSellingPlan ? this.dataset.sellingPlanLabel : available ? this.button.dataset.addLabel : variant?.id ? this.button.dataset.soldOutLabel : this.button.dataset.unavailableLabel;
      if (this.planMessage) this.planMessage.hidden = !state.requiresSellingPlan;
    }
  });
}
